<main class="column-layout-container">
  <div class="menu animate-in-from-left" [class.mobile-shown]="appService.mobileMenuShown">
    <div class="menu-top d-flex justify-content-between align-items-center">
      <fui-heading [text]="'sphere.upcoming_events_title' | translate" [level]="5"></fui-heading>
      <div>
        <button class="fa-button m-r-10" [ngbTooltip]="(refreshing ? 'general.refreshing_dots' : 'general.refresh') | translate" placement="bottom" (click)="refresh()">
          <fa-icon icon="sync" class="action refresh circle-icon-btn" [animation]="refreshing ? 'spin' : undefined"></fa-icon>
        </button>
      </div>
    </div>
    @if (events && events.length) {
      <ul class="menu-options">
        @for (event of events; track event) {
          <li class="menu-option detailed" [class.active]="event.id_events == selectedID">
            <div
              class="primary-option"
              tabindex="0"
              (keyup.enter)="appService.mobileMenuShown = false; selectEvent(event.id_events)"
              (click)="appService.mobileMenuShown = false; selectEvent(event.id_events)"
            >
              <div class="d-flex">
                <img src="./assets/icons/event-icon.png" alt="Event icon" />
                <div>
                  <span class="title">{{ event.title_events }}</span>
                  <br />
                  <span class="extra-info">
                    @if (event.startdate_events && event.enddate_events && event.startdate_events == event.enddate_events) {
                      @if (event.startdate_events && event.starttime_events) {
                        <span>{{ event.start_utc | date: "MMM Do h:mma" : false }}</span>
                      }
                      @if (event.startdate_events && !event.starttime_events) {
                        <span>{{ event.start_utc | date: "MMM Do" : false }}</span>
                      }
                      @if (event.endtime_events) {
                        <span>- {{ event.end_utc | date: "h:mma" : false }}</span>
                      }
                    }
                    @if (event.startdate_events && event.enddate_events && event.startdate_events != event.enddate_events) {
                      @if (event.startdate_events && event.starttime_events) {
                        <span>{{ event.start_utc | date: "MMM Do h:mma" : false }}</span>
                      }
                      @if (event.startdate_events && !event.starttime_events) {
                        <span>{{ event.start_utc | date: "MMM Do" : false }}</span>
                      }
                      @if (event.enddate_events && event.endtime_events) {
                        <span>- {{ event.enddate_events + " " + event.endtime_events | date: "MMM Do h:mma" : false }}</span>
                      }
                      @if (event.enddate_events && !event.endtime_events) {
                        <span>- {{ event.enddate_events | date: "MMM Do" : false }}</span>
                      }
                    }
                    @if (event.startdate_events && !event.enddate_events) {
                      @if (event.startdate_events && event.starttime_events) {
                        <span>{{ event.start_utc | date: "MMM Do h:mma" : false }}</span>
                      }
                      @if (event.startdate_events && !event.starttime_events) {
                        <span>{{ event.start_utc | date: "MMM Do" : false }}</span>
                      }
                    }
                    @if (event.in_progress) {
                      <div class="c-pink">In Progress</div>
                    }
                  </span>
                </div>
              </div>
            </div>
          </li>
        }
      </ul>
    }
  </div>
  <div class="content animate-in-from-right" [class.mobile-shown]="!appService.mobileMenuShown">
    @if (selectedID) {
      <div class="content-constrained">
        <div class="mobile-back-btn" (click)="appService.mobileMenuShown = true">
          <fa-icon icon="chevron-left"></fa-icon>
          Events
        </div>
        <ng-container>
          <myp-event-detail></myp-event-detail>
        </ng-container>
      </div>
    }
    @if (!selectedID) {
      <div class="w-full h-full d-flex justify-content-center align-items-center">
        <span>No event selected.</span>
      </div>
    }
  </div>
</main>
